import * as STD from '@emersya/mpa-std-lib';

import CM                     from '@emersya/mpa-components-manager-lib';
import { Field, InputSelect } from '@emersya/mpa-components-lib';

// import { Field, Image, InputSelect } from '@emersya/mpa-components-lib';

export interface IPlannerFloorEditorComponentConfiguration extends Field.Configuration {
	hasDisclaimer : boolean;
};

export class PlannerFloorEditorComponent extends Field.Component {
	static override initialize() {
		super.initialize();
	};

	private async updateOptions(event : STD.events.Event<any, CM.Component<any, any>>) {
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		const floorPart = app.basket.basket.currentProduct.getPart([ 'floor' ]);
		floorPart.options.length = 0;
		floorPart.currentOption = null;
		// TODO : And of course, add current options.
		const inputSelect = <InputSelect.Component> this.component_find('@:content.options');
		for (const c of Array.from(inputSelect.component_outerChilds)) {
			await c.component_delete();
		}
		for (const fakeTitle of inputSelect.component_querySelectorAll('.fake-title')) {
			fakeTitle.remove();
		}
		const updatedProduct = app.basket?.basket.currentProduct?.sku?.value;
		if (!updatedProduct) {
			throw STD.errors.user('error while loading new sku product from basket');
		}
		const component = app.component_configuration.productsComponents.find(x => x.type === '@floor');
		if (!component) {
			throw STD.errors.user('No component with type @floor');
		}
		const relatedOptions = app.component_configuration.productsOptions.filter(x => x.component ===
			component.SKU &&
			x.products.find(y => y === updatedProduct));

		await app.fillComponentOptions(this, floorPart, inputSelect, relatedOptions, 'viewer-planner-floor-optionTile', event);


		/*const includedOptions = relatedOptions.filter(x => !x.price ||
			!(<any> x.price[ app.currentCurrency.id ]).price ||
			!(<any> x.price[ app.currentCurrency.id ]).price.inclTax);
		const inOptionOptions = relatedOptions.filter(x => !includedOptions.includes(x));
		const x2f = async (opts : typeof relatedOptions) => {
			for (const optionDescriptor of opts) {
				const tr = STD.translationsManager.languages.reduce<Record<string, string>>((a, c) => {
					a[ c ] = optionDescriptor.SKU;
					return a;
				}, {});
				const translations = optionDescriptor.translations[ '@name' ];
				if (!translations) {
					this.component_throwUserError('Missing trad @name for floor option : ' + optionDescriptor.SKU);
				}
				const currentTrad = translations[ app.currentLanguage ];
				if (!currentTrad) {
					this.component_throwUserError('Missing trad @name for floor option :' +
						optionDescriptor.SKU +
						' for language ' +
						app.currentLanguage);
				}
				const price = optionDescriptor?.price?.[ app.currentCurrency.id ]?.price;
				floorPart.createOption({
					id :            optionDescriptor.SKU,
					title :         currentTrad,
					reference :     { value : optionDescriptor.SKU },
					components :    [],
					metaData :      <any> {
						viewerGroups : optionDescriptor.viewerGroups,
						translations : translations,
						SKU :          optionDescriptor.additionalData?.SKU,
						RGB :          optionDescriptor.additionalData?.RGB,
						icon :         optionDescriptor.iconURL
					},
					price :         (<any> price || null),
					technicalFees : null
				});
				const tile = <CM.DOMComponent<any, any, any>> await inputSelect.component_instantiateOuterChild<PlannerFloorTileNS.Configuration>(
					{
						type :          'viewer-planner-floor-optionTile',
						id :            optionDescriptor.SKU,
						tree :          this.component_tree,
						slot :          null,
						isSlot :        false,
						declaredSlot :  null,
						configuration : {
							SKU :                    optionDescriptor.SKU,
							component :              optionDescriptor.component,
							'@innerConfigurations' : {
								'image' : <Image.Configuration> {
									'@translations' : {
										'name' : tr
									},
									'URL' :           optionDescriptor.iconURL
								}
							},
							'@translations' :        {
								text : STD.translationsManager.languages.reduce<STD.translationsManager.TranslationMapping>((a, c) => {
									a[ c ] =
										`${ (<STD.translationsManager.TranslationMapping> optionDescriptor.translations[ '@name' ])[ c ] } (${ optionDescriptor.additionalData?.SKU })`;
									return a;
								}, {})
							}
						}
					}
				);
				await tile.component_initialize();
				await tile.component_start(event);
			}
		};
		this.component_defineTranslation('included', (<any> this.component_configuration[ '@translations' ]).included, true);
		this.component_defineTranslation('optional', (<any> this.component_configuration[ '@translations' ]).optional, true);
		inputSelect.component_DOM.appendChild(STD.DOM.factory({
			tag :       'h3',
			dataset :   {
				translation : <string> this.component_generateTranslationId('included')
			},
			classList : [ 'fake-title' ],
			style :     {
				marginRight : '100%'
			}
		}));
		await x2f(includedOptions);
		inputSelect.component_DOM.appendChild(STD.DOM.factory({
			tag :       'h3',
			dataset :   {
				translation : <string> this.component_generateTranslationId('optional')
			},
			classList : [ 'fake-title' ],
			style :     {
				marginRight : '100%',
				whiteSpace :  'nowrap'
			}
		}));
		await x2f(inOptionOptions);
		*/
		STD.translationsManager.update(this.component_DOM);
	};

	async reset(event : STD.events.Event<any, CM.Component<any, any>>) {
		await this.updateOptions(event);
		const defaultFloorSKU = app.currentDefaults.floor;
		if (defaultFloorSKU) {
			const select = <InputSelect.Component> this.component_find('@:content.options');
			await select.updateValueFromId(defaultFloorSKU);
		}
	};

	override async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		await super.onValueUpdated(ev);
		const select = <InputSelect.Component> this.component_find('@:content.options');
		const option = select.value;
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		const floorPart = app.basket.basket.currentProduct.getPart([ 'floor' ]);


		if (!option) {
			if (floorPart.currentOption) {
				await floorPart.unuseOption();
			}
		} else {
			if (floorPart.currentOption && floorPart.currentOption.id === option.id) {
				return;
			}
			await floorPart.useOption(option.id);
		}
		this.dispatchEvent('floorChanged');
	};

	async addDisclaimer(){
		const disclaimer = await this.component_find('@:content').component_instantiateOuterChild({
			type :          'block',
			isSlot :        false,
			declaredSlot :  null,
			id :            'disclaimerConfortPrestige',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : {}
		});
		await disclaimer.component_instantiateOuterChild({
			type :          'image',
			isSlot :        false,
			declaredSlot :  null,
			id :            'imageInformation',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : {
				URL : (app.clientAppParameters.app.assetsPath +
					'icon-infos.png').replace('CH1U0ZGKSI', 'E3GC4QDIZW').
							replace('XUJG0A2TF5', 'STAODAZNIS').
							replace('sam1_12345', 'STAODAZNIS'),
				'@translations' : {
					name : {
						'en' : 'information icon',
						'fr' : 'Icone information'
					}
				}
			}
		});
		await disclaimer.component_instantiateOuterChild({
			type :          'text',
			isSlot :        false,
			declaredSlot :  null,
			id :            'textInformation',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : {}
		});
	};

	override async component_initialize() {
		await this.component_find('@:content').component_instantiateOuterChild({
			type :          'input-select',
			isSlot :        false,
			declaredSlot :  null,
			id :            'options',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : {}
		});
		if((<IPlannerFloorEditorComponentConfiguration>this.component_configuration).hasDisclaimer){
			await this.addDisclaimer();
		}
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		for (const product of app.basket.basket.products) {
			const part = product.createPart({
				id :        'floor',
				title :     'Floor',
				reference : null,
				metaData :  null,
				parts :     [],
				options :   []
			});
			await part.initialize();
		}
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IPlannerFloorEditorComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});

	};
};
export namespace NS {
	export const Component = PlannerFloorEditorComponent;
	export type Component = PlannerFloorEditorComponent;
	export type Configuration = IPlannerFloorEditorComponentConfiguration;
}
import manifestXMLSource      from './PlannerFloorEditor.xml';
import './PlannerFloorEditor.scss';
// import { NS as PlannerFloorTileNS }  from '../OptionTile/PlannerFloorOptionTile';

CM.declare({
	id :       'viewer-planner-floor-editor',
	type :     PlannerFloorEditorComponent,
	manifest : manifestXMLSource
});
